<template>
  <Loader :loading="httpSend">
    <div v-show="!list_solicitacoes.length || list_solicitacoes.length < 1" role="alert" aria-live="polite"
         aria-atomic="true" class="alert alert-primary text-center">
      Sem solicitações
    </div>
    <div v-show="list_solicitacoes.length && list_solicitacoes.length > 0" class="table-responsive mb-0">
      <table class="table table-centered table-nowrap">
        <thead class="thead-light">
        <tr>
          <th>Protocolo</th>
          <th>Pessoa</th>
          <th>CPF/CNPJ</th>
          <th>Status</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="s in list_solicitacoes" :key="s.tps_codigo">
          <td>
            <span class="text-body font-weight-bold" v-if="!s.ceh_protocolo">-</span>
            <span class="text-body font-weight-bold" v-else>{{ s.ceh_protocolo }}</span>
          </td>
          <td>{{ s.tps_razao_social_nome }}</td>
          <td>
            <span v-if="s.tps_cpf_cnpj.length < 12">{{ s.tps_cpf_cnpj | VMask('###.###.###-##') }}</span>
            <span v-else>{{ s.tps_cpf_cnpj| VMask('##.###.###/####-##') }}</span>
          </td>
          <td>
            <span v-if="!s.chm_status" class="badge badge-dark font-size-12">Rascunho</span>
            <span v-if="s.chm_status === '1'" class="badge badge-primary font-size-12">Solicitada</span>
            <span v-if="s.chm_status === '2'" class="badge badge-info font-size-12">Em Andamento</span>
            <span v-if="s.chm_status === '3'" class="badge badge-warning font-size-12">Pendente</span>
            <span v-if="s.chm_status === '4'" class="badge badge-danger font-size-12">Rejeitada</span>
            <span v-if="s.chm_status === '9'" class="badge badge-success font-size-12">Aprovada</span>
          </td>
          <td class="text-right">
            <button v-if="s.chm_status && s.chm_status!=='4'" type="button"
                    @click="visualizar(s)" class="btn btn-sm btn-outline-dark mr-2">
              Visualizar
            </button>
            <button v-if="!s.chm_status || s.chm_status==='3'" type="button"
                    @click="edit(s)" class="btn btn-sm btn-outline-dark mr-2">
              Editar
            </button>
            <button type="button" v-if="s.chm_status" @click="historico(s)"
                    class="btn btn-sm btn-outline-primary mr-2">
              Histórico
            </button>
            <button @click="relSolicitacao(s)" v-if="s.chm_status" type="button"
                    class="btn btn-sm btn-outline-info">Cartão
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </Loader>
</template>
<script>
import Loader from "@/components/widgets/loader";
import {listSolicitacao} from "@/api/solicitacao/pessoa";
import {impressao} from "@/helps/impressao";
import {setRelSolicitacaoCadastro} from "@/api/relatorio/contribuinte";

export default {
  components: {
    Loader,
  },
  data() {
    return {
      list_solicitacoes: [],
      httpSend: false,
    };
  },
  created() {
    this.getSolicitacao();
  },
  methods: {
    getSolicitacao() {
      this.httpSend = true;
      listSolicitacao().then(result => {
        this.list_solicitacoes = result.dados
      }).catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    visualizar(solicitacao) {
      this.$router.push({
        name: 'contribuinte-solicitacao-visualizar',
        params: {tps_hash: solicitacao.tps_hash}
      })
    },
    edit(solicitacao) {
      let tipo = parseInt(solicitacao.tps_tipo);
      let rota = "";
      switch (tipo) {
        case 1:
          rota = 'contribuinte-solicitacao-fisica-autonomo';
          break;
        case 2:
          rota = 'contribuinte-solicitacao-fisica-avulso';
          break;
        case 3:
          rota = 'contribuinte-solicitacao-juridica-prestador';
          break;
        case 4:
          rota = 'contribuinte-solicitacao-juridica-nao-prestador';
          break;
        case 5:
          rota = 'contribuinte-solicitacao-juridica-contabilidade';
          break;
        case 6:
          rota = 'contribuinte-solicitacao-juridica-cartorio';
          break;
      }
      this.$router.push({
        name: rota,
        props: {isEdit: true},
        params: {tps_hash: solicitacao.tps_hash}
      })
    },
    historico(solicitacao) {
      this.$router.push({
        name: "contribuinte-solicitacao-historico",
        props: {isEdit: true},
        params: {ceh_codigo: solicitacao.ceh_codigo}
      })
    },
    relSolicitacao(solicitacao) {
      this.httpSend = true;
      impressao(setRelSolicitacaoCadastro(solicitacao.tps_hash), 'P').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
  }
};
</script>

